import request from '@/router/axios'

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/wage' : '/wage'
const urlBizPrefix = '/bizwage'

// 员工收入明细表
export function selectDataForSalaryDetail(data) {
  return request({
    url: urlPrefix + '/salaryHistory/selectDataForSalaryDetail',
    method: 'post',
    data
  })
}

// 员工收入汇总表
export function selectDataForSalaryGroupCount(data) {
  return request({
    url: urlPrefix + '/salaryHistory/selectDataForSalaryGroupCount',
    method: 'post',
    data
  })
}

// 保存收入汇总报表自定义表头
export function updataSalaryGroupHeaderInfo(obj) {
  return request({
    url: urlPrefix + '/payoutheaderinfo/updataSalaryGroupHeaderInfo',
    method: 'post',
    data: obj
  });
}

// 员工收入明细表tags下载
export function getSalaryDataByTabsDownload(data) {
  return request({
    url: urlPrefix + '/report/getSalaryDataByTabsDownload',
    method: 'post',
    data
  })
}

// 瑞晨宠物医院下载
export function getCusRelDataForSalaryDetailForExport(data) {
  return request({
    url: urlBizPrefix + '/bspsalary/getCusRelDataForSalaryDetailForExport',
    method: 'post',
    data
  })
}
